export type PutDataKindRequest = {
  dfnSetVerNum?: string;
  dataKindList?: PutDataKind[];
  fileLayoutList?: PutFileLayout[];
};

export type PutDataKind = {
  index: number;
  delFlg: string;
  dtKindId: string;
  mltcstDsbldFlg: string;
  dtKindNameLclLang?: string;
  dtKindNameEng?: string;
  dtKindNameWtngChngLclLang?: string;
  dtKindNameWtngChngEng?: string;
  updateDateTime?: string;
};
export type PutFileLayout = {
  index: number;
  delFlg: string;
  dtKindId: string;
  fileId: string;
  ownCpntId?: string;
  bsFileFlg?: string;
  frkRsnTypCd?: string;
  updateDateTime?: string;
  addFlag?: String;
};
